import { Action, Dispatch } from 'redux'
import { openConfirmModalAction } from 'reducks/modal/actions'

const openConfirmModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openConfirmModalAction())
  }
}

export default openConfirmModal
